<template>
  <ITMPage>
    <h2>Customers</h2>
    <DataTableAsync class="mt-3" :data="tableData" v-model="tableState" :length="(data || []).length" ref="dataTable" noSearch>
      <template #menu>
        <div class="hvh-flex align-center" v-if="isAdmin">
          <v-btn flat class="hvh-btn hvh-btn--secondary" @click="customerForEdit = {}" v-if="isAdmin">Add</v-btn>
        </div>
      </template>
      <template #head>
        <tr>
          <Th prop="customerNumber" sort>Customer #</Th>
          <Th prop="facilityName" sort>Facility/Name</Th>
          <Th prop="address" sort>Address</Th>
          <Th prop="city" sort>City</Th>
          <Th prop="state" sort>State</Th>
          <Th prop="zip" sort>Zip</Th>
          <Th prop="email" sort>Email</Th>
          <Th prop="contactNumber" sort>Phone</Th>
          <Th prop="contact" sort>Contact</Th>
          <Th prop="ramLicenseId" sort>RAM License Id</Th>
          <Th prop="amendId" sort>Amend Id</Th>
          <Th prop="expDate" sort>Expiration Date</Th>
          <th />
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ item.customerNumber }}</td>
          <td>{{ item.facilityName }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.city }}</td>
          <td>{{ item.state }}</td>
          <td>{{ item.zip }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.contactNumber }}</td>
          <td>{{ item.contact }}</td>
          <td>{{ item.ramLicenseId }}</td>
          <td>{{ item.amendId }}</td>
          <td>{{ item.expDate }}</td>

          <td class="text-center">
            <v-icon @click="customerForEdit = item">{{ isAdmin ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
          </td>
        </tr>
      </template>
    </DataTableAsync>
    <Loader v-if="isLoading" />
    <ITMAddCustomer :value="customerForEdit" :readOnly="!isAdmin" :isLoading="isLoading" @input="customerForEdit.customerNumber ? editCustomer($event) : addCustomer($event)" @close="customerForEdit = null" v-if="customerForEdit" />
  </ITMPage>
</template>

<script>
import ITMPage from '../../components/itm/ITMPage.vue';
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue';
import Th from '../../components/common/dataTable/Th.vue';
import axios from '../../axios';
import { errorDebug, } from '../../libraries/common';
import ITMAddCustomer from '../../components/itm/ITMAddCustomer.vue';
export default {
  components: { ITMPage, DataTableAsync, Th, ITMAddCustomer },
  data() {
    return {
      data: null,
      tableState: { page: 1, perPage: 25 },
      isLoading: false,
      customerForEdit: null,
    };
  },
  computed: {
    sortedData() {
      var response = (this.data || []);

      if (this.tableState.sortByProp) {
        response = response.sortBy(this.tableState.sortByProp);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response;
    },
    tableData() {
      return this.sortedData
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    isAdmin() {
      return this.$store.state.user.isMainAdmin || this.$store.state.user.isAdmin;
    }
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/ITM/Customers/GetCustomers`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    addCustomer(customer) {
      this.isLoading = true;
      axios.post('/ITM/Customers/AddCustomer', customer)
        .then(({ data }) => {
          this.data.unshift(data);
          this.customerForEdit = null;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    editCustomer(customer) {
      this.isLoading = true;
      axios.put(`/ITM/Customers/EditCustomer/${customer.customerNumber}`, customer)
        .then(({ data }) => {
          var customerForEdit = this.data.find(f => f.customerNumber === customer.customerNumber);
          Object.assign(customerForEdit, data);
          this.data = [...this.data];
          this.customerForEdit = null;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomers'] = this;
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  border-bottom: 1px solid #002f6c;
  cursor: pointer;
}
</style>